// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CommunityHero — /community page hero
   Inherits hero__rail, hero__line, hero__line-inner from Hero.css
   via shared classes. Own tokens defined here.
   ============================================================ */

.cmhero {
  position: relative;
  height: 100dvh;
  background: var(--c-cream);
  overflow: hidden;
  isolation: isolate;
}

/* ── Background media ───────────────────────────────────────── */
.cmhero__media {
  position: absolute;
  inset: 0;
  mix-blend-mode: multiply;
  z-index: -1;
}

.cmhero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Shift image right so mountain peaks sit on the right half */
  object-position: 65% center;
}

/* Cream scrim — same fade pattern as home hero */
.cmhero__scrim {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 26%, rgba(244, 239, 230, 0.82) 42%, rgba(244, 239, 230, 0.22) 62%, rgba(244, 239, 230, 0) 78%),
    linear-gradient(to top, rgba(27, 27, 27, 0.18) 0%, rgba(27, 27, 27, 0) 38%);
}

/* ── Circular badge top-right ───────────────────────────────── */
.cmhero__badge-pos {
  top: clamp(5rem, 10vh, 9rem);
  right: clamp(2rem, 8vw, 8rem);
  z-index: 4;
}

/* ── Layout shell ───────────────────────────────────────────── */
.cmhero__inner {
  position: relative;
  height: 100dvh;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: clamp(1rem, 2.5vw, 2.25rem);
  padding-top: 64px; /* clear fixed navbar */
  z-index: 3;
}

/* Rail — reuse hero__rail classes exactly */
.cmhero__rail {
  /* identical to .hero__rail; inherits from Hero.css via shared class */
}

/* ── Content ────────────────────────────────────────────────── */
.cmhero__content {
  max-width: 52rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: clamp(0.85rem, 1.5vw, 1.25rem);
}

/* Eyebrow */
.cmhero__eyebrow {
  /* u-eyebrow base; accent colour override */
  color: var(--accent) !important;
  letter-spacing: 0.24em;
}

/* Headline — forest green, both lines */
.cmhero__title {
  color: var(--c-forest);
  font-size: clamp(2.8rem, 7.5vw, 7rem);
  line-height: 0.92;
  margin: 0;
}

/* Short rust rule */
.cmhero__rule {
  display: block;
  width: clamp(2.5rem, 5vw, 4rem);
  height: 3px;
  background: var(--accent);
  flex-shrink: 0;
  margin-block: 0.25rem;
}

/* Body copy */
.cmhero__sub {
  font-family: var(--font-body);
  font-size: clamp(0.95rem, 1.3vw, 1.1rem);
  color: var(--c-ink);
  line-height: 1.7;
  max-width: 32rem;
  margin: 0;
}

/* ── Lives impacted stat ────────────────────────────────────── */
.cmhero__stat {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-top: 0.5rem;
}

.cmhero__stat-icon {
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  color: var(--accent);
  display: flex;
  align-items: center;
  line-height: 1;
  flex-shrink: 0;
}

.cmhero__stat-body {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
}

.cmhero__stat-num {
  font-family: var(--font-display);
  font-size: clamp(1.8rem, 3.5vw, 3rem);
  font-weight: 400;
  color: var(--c-ink);
  line-height: 1;
  letter-spacing: -0.01em;
}

.cmhero__stat-label {
  font-family: var(--font-body);
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--text-muted);
}

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 991.98px) {
  .cmhero__img {
    object-position: 60% center;
  }
  .cmhero__scrim {
    background:
      linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 32%, rgba(244, 239, 230, 0.85) 52%, rgba(244, 239, 230, 0.3) 72%, rgba(244, 239, 230, 0.05) 100%),
      linear-gradient(to top, rgba(27, 27, 27, 0.25) 0%, rgba(27, 27, 27, 0) 44%);
  }
  .cmhero__badge-pos {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .cmhero__inner {
    grid-template-columns: 1fr;
    padding-inline: var(--gutter);
  }
  .cmhero__rail {
    display: none;
  }
  .cmhero__content {
    max-width: 100%;
    padding-bottom: 0;
  }
  .cmhero__title {
    font-size: clamp(2.4rem, 10vw, 4rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CommunityHero.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8DAA8D;EAC9D,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,QAAQ;EACR;;+EAE6E;AAC/E;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB,EAAE,uBAAuB;EAC1C,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,sEAAsE;AACxE;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,YAAY;AACZ;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iBAAiB;EACjB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,kEAAkE;AAClE;EACE;IACE,2BAA2B;EAC7B;EACA;IACE;;iFAE6E;EAC/E;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":["/* ============================================================\n   CommunityHero — /community page hero\n   Inherits hero__rail, hero__line, hero__line-inner from Hero.css\n   via shared classes. Own tokens defined here.\n   ============================================================ */\n\n.cmhero {\n  position: relative;\n  height: 100dvh;\n  background: var(--c-cream);\n  overflow: hidden;\n  isolation: isolate;\n}\n\n/* ── Background media ───────────────────────────────────────── */\n.cmhero__media {\n  position: absolute;\n  inset: 0;\n  mix-blend-mode: multiply;\n  z-index: -1;\n}\n\n.cmhero__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  /* Shift image right so mountain peaks sit on the right half */\n  object-position: 65% center;\n}\n\n/* Cream scrim — same fade pattern as home hero */\n.cmhero__scrim {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 26%, rgba(244, 239, 230, 0.82) 42%, rgba(244, 239, 230, 0.22) 62%, rgba(244, 239, 230, 0) 78%),\n    linear-gradient(to top, rgba(27, 27, 27, 0.18) 0%, rgba(27, 27, 27, 0) 38%);\n}\n\n/* ── Circular badge top-right ───────────────────────────────── */\n.cmhero__badge-pos {\n  top: clamp(5rem, 10vh, 9rem);\n  right: clamp(2rem, 8vw, 8rem);\n  z-index: 4;\n}\n\n/* ── Layout shell ───────────────────────────────────────────── */\n.cmhero__inner {\n  position: relative;\n  height: 100dvh;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  column-gap: clamp(1rem, 2.5vw, 2.25rem);\n  padding-top: 64px; /* clear fixed navbar */\n  z-index: 3;\n}\n\n/* Rail — reuse hero__rail classes exactly */\n.cmhero__rail {\n  /* identical to .hero__rail; inherits from Hero.css via shared class */\n}\n\n/* ── Content ────────────────────────────────────────────────── */\n.cmhero__content {\n  max-width: 52rem;\n  padding-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.85rem, 1.5vw, 1.25rem);\n}\n\n/* Eyebrow */\n.cmhero__eyebrow {\n  /* u-eyebrow base; accent colour override */\n  color: var(--accent) !important;\n  letter-spacing: 0.24em;\n}\n\n/* Headline — forest green, both lines */\n.cmhero__title {\n  color: var(--c-forest);\n  font-size: clamp(2.8rem, 7.5vw, 7rem);\n  line-height: 0.92;\n  margin: 0;\n}\n\n/* Short rust rule */\n.cmhero__rule {\n  display: block;\n  width: clamp(2.5rem, 5vw, 4rem);\n  height: 3px;\n  background: var(--accent);\n  flex-shrink: 0;\n  margin-block: 0.25rem;\n}\n\n/* Body copy */\n.cmhero__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.95rem, 1.3vw, 1.1rem);\n  color: var(--c-ink);\n  line-height: 1.7;\n  max-width: 32rem;\n  margin: 0;\n}\n\n/* ── Lives impacted stat ────────────────────────────────────── */\n.cmhero__stat {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin-top: 0.5rem;\n}\n\n.cmhero__stat-icon {\n  font-size: clamp(1.8rem, 3vw, 2.6rem);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.cmhero__stat-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.05rem;\n}\n\n.cmhero__stat-num {\n  font-family: var(--font-display);\n  font-size: clamp(1.8rem, 3.5vw, 3rem);\n  font-weight: 400;\n  color: var(--c-ink);\n  line-height: 1;\n  letter-spacing: -0.01em;\n}\n\n.cmhero__stat-label {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n@media (max-width: 991.98px) {\n  .cmhero__img {\n    object-position: 60% center;\n  }\n  .cmhero__scrim {\n    background:\n      linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 32%, rgba(244, 239, 230, 0.85) 52%, rgba(244, 239, 230, 0.3) 72%, rgba(244, 239, 230, 0.05) 100%),\n      linear-gradient(to top, rgba(27, 27, 27, 0.25) 0%, rgba(27, 27, 27, 0) 44%);\n  }\n  .cmhero__badge-pos {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .cmhero__inner {\n    grid-template-columns: 1fr;\n    padding-inline: var(--gutter);\n  }\n  .cmhero__rail {\n    display: none;\n  }\n  .cmhero__content {\n    max-width: 100%;\n    padding-bottom: 0;\n  }\n  .cmhero__title {\n    font-size: clamp(2.4rem, 10vw, 4rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
